import React from 'react';
import MessageValidation from './../../MessageValidation';
import {Input} from 'antd'
const PasswordInput = React.forwardRef((props, ref) => {
    return (
        <React.Fragment>
            <Input.Password
                {...props}
                ref={ref}
                autoComplete="off"
                onChange={props.onChange}
                style={{...(props.styles || {}), borderColor: props.error ? 'red' : undefined}}
            />
            <MessageValidation validation={!!props.error} message={props.error} />
        </React.Fragment>
    )
})
export default PasswordInput;
